/* DVY header: mobile menu drawer. */
class DvyHeader extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('#DvyMenuDrawer');
    this.toggle = this.querySelector('[data-dvy-menu-open]');
    if (!this.dialog || !this.toggle) return;
    this.toggle.addEventListener('click', () => this.open());
    this.dialog.querySelector('[data-dvy-menu-close]')?.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('close', () => {
      this.toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      this.toggle.focus();
    });
  }

  open() {
    this.dialog.showModal();
    this.toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
}

if (!customElements.get('dvy-header')) customElements.define('dvy-header', DvyHeader);
